import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appDateMask]'
})
export class DateMaskDirective {

  constructor(private el: ElementRef) {
    this.el.nativeElement.value = '--/--/----';
  }

  @HostListener('focus', ['$event']) onFocus(event: FocusEvent): void {
    const input = this.el.nativeElement;
    if (input.value === '') {
      input.value = '--/--/----';
    }
    this.setCursorPosition(input, this.el.nativeElement.value.indexOf('-'));
  }

  @HostListener('input', ['$event']) onInputChange(event: InputEvent): void {
    const input = this.el.nativeElement;
    let inputValue = input.value.replace(/[^0-9]/g, '').slice(0, 8);
    const defaultDate = '--/--/----';

    let formattedValue = defaultDate.split('');
    let cursorPosition = input.selectionStart;

    for (let i = 0, j = 0; i < inputValue.length; i++, j++) {
      if (j === 2 || j === 5) j++;
      formattedValue[j] = inputValue[i];
    }

    input.value = formattedValue.join('');

    if (cursorPosition === 2 || cursorPosition === 5) {
      cursorPosition++;
    }

    this.setCursorPosition(input, cursorPosition);
  }

  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent): void {
    const input = this.el.nativeElement;
    let cursorPosition = input.selectionStart;

    if (event.key === 'Backspace') {
      if (cursorPosition === 3 || cursorPosition === 6) {
        cursorPosition--;
      }
      cursorPosition--;


      if (cursorPosition >= 0) {
        const valueArray = input.value.split('');
        valueArray[cursorPosition] = '-';
        input.value = valueArray.join('');
      }

      if (cursorPosition < 0) cursorPosition = 0;

      this.setCursorPosition(input, cursorPosition);
      event.preventDefault(); 
    }
  }

  private setCursorPosition(input: HTMLInputElement, position: number): void {
    setTimeout(() => {
      input.setSelectionRange(position, position);
    }, 0);
  }
}